export const followConfigFormModel = {
  formId: 'FollowConfigForm',
  formField: {
    scoreThreshold: {
      name: 'scoreThreshold',
      label: 'Puntaje máximo para seguimiento',
      requiredErrorMsg: 'El puntaje es obligatorio',
      invalidErrorMsg: 'Debe ser un número válido',
    },
  },
};
